import { memo } from 'react'
import { Grid2 } from '@mui/material'

import PageTitle from '../shared/pageTitle/PageTitle'
import ProdegeFrame from './ProdegeFrame'
import brandConfig from 'brandConfig'
import Note from './Note'

const Prodege = ({ t, authId, symbol }) => {
  const pageTitle = t('games.play-games')
  return (
    <>
      <PageTitle
        title={pageTitle}
        desc={t('games.play-games-desc', { symbol })}
      />
      <Grid2 container spacing={3}>
        <Grid2 size={{ xs: 12, md: 8 }}>
          <ProdegeFrame authId={authId} token={brandConfig.prodegeToken} />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 4 }}>
          <Note t={t} />
        </Grid2>
      </Grid2>
    </>
  )
}

export default memo(Prodege)
